import { PHONE, locationSchema } from "../structured-data-core";

export function getPortlandStructuredData() {
  const url = "https://restorehair.com/locations/oregon/portland/";
  const description =
    "Find out about your hair transplant options in Portland with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    locationSchema("Portland", "205 SE Spokane St, Suite 300", "Portland", "OR", PHONE, url, description),
  ];
}
